export const DEFAULT_SEARCH_PLACEHOLDER = 'Search vendors, tasks, songs, guidelines, decor, stationery…';
export const ACCOUNT_SEARCH_PLACEHOLDER = 'Search clients, projects, invoices, quotes, vendors…';

/**
 * List pages whose rows are narrowed by the global header box (through
 * useHeaderSearch). The box says so, since these pages carry no search field
 * of their own.
 */
const LIST_PAGE_PLACEHOLDERS: Readonly<Record<string, string>> = {
  '/procurement': 'Search inventory…',
  '/procurement/inventory': 'Search inventory…',
  '/procurement/orders': 'Search orders…',
  '/procurement/shipments': 'Search shipments…',
  '/procurement/shipping': 'Search shipping agents…',
  '/venue': 'Search venues…',
};

/** The list-page wording for this path, or null when the box is the plain omni-search. */
export function pageSearchPlaceholder(pathname: string): string | null {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  return LIST_PAGE_PLACEHOLDERS[path] ?? null;
}

export function globalSearchPlaceholder(pathname: string, accountScope: boolean): string {
  return pageSearchPlaceholder(pathname) ?? (accountScope ? ACCOUNT_SEARCH_PLACEHOLDER : DEFAULT_SEARCH_PLACEHOLDER);
}
